module.exports = __webpack_public_path__ + "img/lock_quiz.2c52786d.gif";